<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <Card :title="'Tambah Kartu Stok'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'inventory-stocks'"
            />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Form from "@/component/inventory/MaintainStockForm.vue";

export default {
  name: "Add",

  components: {
    Card,
    Form,
  },

  data() {
    return {
      // Form
      form: {
          stock_in_out: 0
      },
      
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Inventori", route: "/inventory/list" },
      { title: "Kartu Stok", route: "/inventory/maintain-stock" },
      { title: "Tambah" },
    ]);
  },
};
</script>

<style>
</style>